<div style="text-align:center;padding-top:20px;" *ngIf="studentExcessiveAttendance.length == 0 && isBusy==false"
  translate>No Excessive Absences data exists for student</div>

<div *ngIf="studentExcessiveAttendance.length > 0 ">
  <div #dropdown style="padding-top: 7px;">
    <tyl-form-field label="View" style="width: 250px;" *ngIf="viewExcessiveAttendanceOptions.length > 0">
      <mat-select id="dropdownExcessiveAttendanceView" [(value)]="selectedExcessiveAttendanceOption"
        (selectionChange)="selectedViewOptionChange()" aria-label="Select item to search by">
        <mat-option *ngFor="let eaOption of viewExcessiveAttendanceOptions" [value]="eaOption.Value">
          {{eaOption.Description}}</mat-option>
      </mat-select>
    </tyl-form-field>

    <tyl-form-field label="Tracking Group" style="width: 250px; padding-left: 10px;"
      *ngIf="viewTrackingGroupsOptions.length > 0">
      <mat-select id="dropdownExcessiveAttendanceView" [(value)]="selectedTrackingGroupOption"
        (selectionChange)="getStudentAttendanceInfo()" aria-label="Select item to search by">
        <mat-option *ngFor="let tgOption of viewTrackingGroupsOptions" [value]="tgOption.Value">{{tgOption.Description}}
        </mat-option>
      </mat-select>
    </tyl-form-field>
  </div>

  <div>
    <div *ngFor="let school of excessiveAttendanceSchools">
      <div
        *ngIf="excessiveAttendanceSchools.length == 1 && studentEnrollment.SchoolName != school.SiteName">
        <b style="font-size: 12pt;padding-bottom:5px;">{{school.SiteName}}</b></div>
      <div *ngIf="excessiveAttendanceSchools.length > 1"><b
          style="font-size: 12pt;padding-bottom:5px;">{{school.SiteName}}</b></div>

      <mat-table #table matSortActive="Meets" matSortDirection="asc"
        [dataSource]="getExcessiveAttendanceDataSource(school.SiteId)" multiTemplateDataRows matSort matSortDisableClear
        aria-label="Excessive Attendance Data Table">
        <ng-container matColumnDef="More">
          <mat-header-cell *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;"><span translate>More</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let att" style="min-width:68px;max-width:68px;text-align:center;color:black;">
            <span aria-label="Expand row for more details">
              <i [ngClass]="checkExpandedExcessiveAttendance(att) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons"
                aria-hidden="true"></i>
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Meets">
          <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Meets</span>
            <filter class="mat-filter" [data]="excessiveAttendanceAngularMatData" columnName="Meets"
              dataType="string"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let att">{{att.Meets}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Steps">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="padding-right: 10px; justify-content: flex-end; min-width: 90px; max-width: 90px;">
              <span translate>Step</span>
            <filter class="mat-filter" [data]="excessiveAttendanceAngularMatData" columnName="Steps"
              dataType="number"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let att" style="padding-right: 10px; justify-content: flex-end; min-width: 90px; max-width: 90px;">
            <span style="padding-right: 20px;">{{att.Steps}}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Points">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="padding-right: 10px; justify-content: flex-end;"><span translate>Points</span>
            <filter class="mat-filter" [data]="excessiveAttendanceAngularMatData" columnName="Points"
              dataType="number"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let att" style="padding-right: 10px; justify-content: flex-end;">
            <span style="padding-right: 20px;">{{att.Points}}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="AppealedStatus">
          <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Appeal Status</span>
            <filter class="mat-filter" [data]="excessiveAttendanceAngularMatData" columnName="AppealedStatus"
              dataType="string"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let att">{{att.AppealedStatus}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="expandRow">
          <td mat-cell *matCellDef="let att;let i = index;" class="mat-detail-card"
            [attr.colspan]="columnsToDisplayExcessiveAttendance.length">
            <div style="width:100%;">
              <table style="width: 100%">
                <thead>
                  <tr style="line-height:normal;">
                    <td
                      style="padding-left:5px;color: #595959;padding: 5px; min-width: 100px; max-width: 100px;"
                      translate>Term</td>
                    <td
                      style="color: #595959;padding: 5px; min-width:100px; max-width: 100px;"
                      translate>Course-Section</td>
                    <td
                      style="color: #595959;padding: 5px; min-width: 100px; max-width: 100px; "
                      translate>Course Name</td>
                    <td
                      style="color: #595959;padding: 5px; min-width: 100px; max-width: 100px; "
                      translate>Teacher</td>
                  </tr>
                </thead>
                <tbody>
                  <tr style="min-height:40px;">
                    <td style="font-size: 14px;padding: 5px; min-width:100px; max-width: 100px;">{{att.Term}}</td>
                    <td style="font-size: 14px;padding: 5px; min-width: 100px; max-width: 100px;">
                      {{att.Subject}}-{{att.Section}}</td>
                    <td style="font-size: 14px;padding: 5px; min-width: 100px; max-width: 100px;">{{att.Course}}</td>
                    <td style="font-size: 14px;padding: 5px; min-width: 100px; max-width: 100px;">{{att.Teacher}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </ng-container>

        <!-- Row definitions -->
        <mat-header-row *matHeaderRowDef="columnsToDisplayExcessiveAttendance"></mat-header-row>
        <mat-row *matRowDef="let row;let i= index; columns: columnsToDisplayExcessiveAttendance;"
          (click)="toggleExpanded(row)" (keydown)="rowKeyPress($event, row)"
          [attr.aria-label]="getExcessiveAttendanceAriaRow(row)"></mat-row>
        <mat-row *matRowDef="let row; columns: ['expandRow']"
          [@detailExpand]="checkExpandedExcessiveAttendance(row) ? 'expanded' : 'collapsed'"
          (@detailExpand.start)="$event.toState == 'expanded' ? excessiveAttendanceAngularMatData.setVisible(row, true) : null"
          (@detailExpand.done)="$event.toState == 'collapsed' ? excessiveAttendanceAngularMatData.setVisible(row, false) : null"
          style="overflow: hidden" class="mat-detail-row"></mat-row>
      </mat-table>
    </div>
  </div>
</div>